<script setup lang="ts">
const props = defineProps<{
  current: number
  goal: number
  autoRefresh: boolean
}>()
const a = ref(new Intl.NumberFormat('de-DE').format(props.goal))
</script>

<template>
  <div class="my-2 w-full">
    <div class="font-bold text-black">
      <span class="text-3xl">{{ current }}</span>

      <span class="ml-1 text-lg">von {{ a }} Unterschriften</span>
    </div>

    <div class="mt-2 h-4 w-full rounded-full bg-gray-200">
      <div
        class="h-4 rounded-full bg-primary-500"
        :style="{ width: (current / goal) * 100 + '%' }"
      />
    </div>
  </div>
</template>
